import React, { CSSProperties, useState } from 'react';
import SortIcon from './SortIcon';

interface TableHeadProps {
  columns: Array<{ label: string; key?: string; } & CSSProperties>;
  sortingBy: string;
  descending: boolean;
  setSortData: (data: { column: string; descending: boolean }) => void;
}

const TableHead = ({
  columns,
  sortingBy,
  descending,
  setSortData,
}: TableHeadProps) => {
  const [hoverColumn, setHoverColumn] = useState('');

  const handleSortIconClick = (label: string) => {
    if (label === sortingBy) {
      return setSortData({ column: sortingBy, descending: !descending });
    }

    return setSortData({ column: label, descending: false });
  };

  return (
    <thead>
      <tr>
        {columns.map(({ label, key, ...style }) => (
          <th
            key={key ?? label}
            style={style}
            onMouseEnter={() => setHoverColumn(label)}
            onMouseLeave={() => setHoverColumn('')}
          >
            {label}

            <SortIcon
              visible={hoverColumn === label || label === sortingBy}
              reversed={label === sortingBy ? descending : false}
              onClick={() => handleSortIconClick(label)}
            />
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHead;
